export default {
  columns: {
    title: 'Titel',
    image: 'Bild',
    button_url: 'Button-URL',
    button_text: 'Button-Text',
    description: 'Beschreibung',
    visible: 'Sichtbar',
    actions: 'Aktionen',
  },
  buttons: {
    create_post: 'Beitrag erstellen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
  },
  title: 'Hervorgehobene Beiträge',
  delete_confirmation: 'Sind Sie sicher, dass Sie diesen Beitrag löschen möchten?',
};
